import * as Yup from "yup";
import { validateEmail, validateConfirmEmail } from "../common";

export const updateRelativesEmailSchema = Yup.object().shape({
  email: validateEmail,
  confirmEmail: validateConfirmEmail("email"),
});
